import PropTypes from 'prop-types';
import styles from './FJNavBar.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJToolTip from '../FJToolTip/FJToolTip.jsx';
import React from 'react';
import FJTextWithEllipsis from '../FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import { useLayoutEffect, useState } from 'react';
import FJConstant from '../../../constants/FJConstant.js';

const FJNavBar = props => {
    const {
        selectTab,
        onChangeTab,
        tabList,
        style,
        isMusicNav,
        className,
        adaptWidth = 1400,
        isCommunityNav = false,
    } = props;
    const [hasTooltip, setHasTooltip] = useState(false);
    useLayoutEffect(() => {
        _checkHasTooltip();

        window.addEventListener('resize', _checkHasTooltip);
        return () => {
            window.removeEventListener('resize', _checkHasTooltip);
        };
    }, []);

    const _checkHasTooltip = () => {
        setHasTooltip(document.body.clientWidth <= adaptWidth);
    };
    return (
        <ul
            className={classNames(
                styles.container,
                isMusicNav && styles.music_nav,
                className,
                isCommunityNav && styles.community_nav,
            )}
            style={style}
        >
            {tabList?.map(tab => (
                <React.Fragment key={tab.value}>
                    {tab.value === FJConstant.LINE ? (
                        <div className={styles.line} />
                    ) : hasTooltip ? (
                        <FJToolTip title={tab.name} classes={{ tooltip: styles.tooltip, arrow: styles.arrow }}>
                            <li
                                className={classNames(styles.item, {
                                    [styles.active]: selectTab === tab.value,
                                })}
                                onClick={() => onChangeTab(tab.value)}
                            >
                                <tab.icon className={styles.icon} />
                            </li>
                        </FJToolTip>
                    ) : (
                        <li
                            className={classNames(styles.item, {
                                [styles.active]: selectTab === tab.value,
                            })}
                            onClick={() => onChangeTab(tab.value)}
                        >
                            <tab.icon className={styles.icon} />
                            <FJTextWithEllipsis className={styles.name} text={FJLocalStore._(tab.name)} />
                            {tab.children}
                        </li>
                    )}
                </React.Fragment>
            ))}
        </ul>
    );
};

FJNavBar.propTypes = {
    selectTab: PropTypes.string,
    onChangeTab: PropTypes.func,
    tabList: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            icon: PropTypes.elementType.isRequired,
        }),
    ),
    style: PropTypes.object,
    isMusicNav: PropTypes.bool,
    hasTooltip: PropTypes.bool,
};

export default FJNavBar;
